import {
  GET_GENERAL_META_DATA,
  GET_GENERAL_META_DATA_RESULT,
  GET_NEW_SESSION_ID,
  NEW_SESSION_ID_SUCCESS,
  ON_APP_LOAD,
  PLAY_KEYSTROKE,
  RECEIVE_TEXT_STREAM,
  RECEIVE_TEXT_STREAM_REFLECTED,
  REQUEST_TEXT_STREAM,
  SAVE_PHOTO,
  SCROLL_TEXT,
  SET_ANIMATION,
  SET_CAPTURED_IMAGE,
  SET_END_OF_STREAM,
  SET_END_OF_STREAM_REFLECTED,
  SET_IS_PHOTO_CAPTURE_OPEN,
  SET_PHOTO_CAPTURE_WIZARD_STEP,
  SET_PLACEHOLDER_MESSAGE,
  SET_SHOULD_FOCUS_INPUT_FIELD,
  SET_SHOULD_FOCUS_SEND_BUTTON,
  SET_SHOW_PHOTO_IS_OPEN,
  SET_WHOS_IN_THE_PHOTO,
  START_PHOTOSHOOT,
  STARTING_COMPLETION,
  TERMINATE,
  TURN_PLACEHOLDER_MESSAGE,
} from './consts'

export const requestTextStream = (prompt, dispatch) => ({
  type: REQUEST_TEXT_STREAM,
  payload: prompt,
  dispatch
});

export const receiveTextStream = ({word, predictionUUID, meta = []}) => ({
  type: RECEIVE_TEXT_STREAM,
  word,
  predictionUUID,
  meta
})

export const receiveTextStreamReflected = ({
                                             word,
                                             predictionUUID,
                                             meta = [],
                                             topN = null,
                                             selectedTopNIndex = -1,
                                             isTopNPanelOpen
                                           }) => ({
  type: RECEIVE_TEXT_STREAM_REFLECTED,
  word,
  predictionUUID,
  meta,
  topN,
  selectedTopNIndex,
  isTopNPanelOpen
})

export const startingCompletion = (prompt) => ({
  type: STARTING_COMPLETION,
  prompt,
})

export const setAnimation = (animation) => ({
  type: SET_ANIMATION,
  payload: animation
})

export const setEndOfStream = ({endOfStream, predictionUUID}) => ({
  type: SET_END_OF_STREAM,
  endOfStream,
  predictionUUID
})

export const setEndOfStreamReflected = ({endOfStream, predictionUUID}) => ({
  type: SET_END_OF_STREAM_REFLECTED,
  endOfStream,
  predictionUUID
})

export const getGeneralMetaData = () => ({
  type: GET_GENERAL_META_DATA,
})

export const getGeneralMetaDataResult = (temp) => ({
  type: GET_GENERAL_META_DATA_RESULT,
  payload: temp,
})

export const onAppLoad = () => ({
  type: ON_APP_LOAD,
})

export const startPhotoshoot = () => ({
  type: START_PHOTOSHOOT,
})

export const scrollText = () => ({
  type: SCROLL_TEXT,
})

export const setIsPhotoCaptureOpen = (isOpen) => ({
  type: SET_IS_PHOTO_CAPTURE_OPEN,
  isOpen,
})

export const setCapturedImage = (image) => ({
  type: SET_CAPTURED_IMAGE,
  image,
})

export const setPhotoCaptureWizardStep = (step) => ({
  type: SET_PHOTO_CAPTURE_WIZARD_STEP,
  step,
})

export const setWhoIsInThePhoto = (text) => ({
  type: SET_WHOS_IN_THE_PHOTO,
  text,
})

export const savePhoto = (capturedImage, whoIsInThePhoto) => ({
  type: SAVE_PHOTO,
  capturedImage,
  whoIsInThePhoto,
})

export const setIsShowPhotoOpen = (isOpen, url) => ({
  type: SET_SHOW_PHOTO_IS_OPEN,
  isOpen,
  url
})

export const playKeystroke = (isHumanKey = false) => ({
  type: PLAY_KEYSTROKE,
  isHumanKey,
})

export const terminate = () => ({
  type: TERMINATE,
})

export const setPlaceHolderMessage = (message) => ({
  type: SET_PLACEHOLDER_MESSAGE,
  message
})

export const turnPlaceHolderMessageAction = () => ({
  type: TURN_PLACEHOLDER_MESSAGE,
})

export const getNewSessionIdAction = () => ({
  type: GET_NEW_SESSION_ID,
})

export const newSessionIdSuccess = () => ({
  type: NEW_SESSION_ID_SUCCESS,
})



export const setShouldFocusSendButton = (shouldFocus = false) => ({
  type: SET_SHOULD_FOCUS_SEND_BUTTON,
  shouldFocus,
})

export const setShouldFocusInputField = (shouldFocus = false) => ({
  type: SET_SHOULD_FOCUS_INPUT_FIELD,
  shouldFocus,
})
